/**
 * Ratgeber archive: AJAX category/tag filter + pagination.
 */
(function () {
	var root = document.querySelector('[data-ratgeber-archive]');
	if (!root || typeof didapressRatgeberArchive === 'undefined') {
		return;
	}

	var list = root.querySelector('[data-ratgeber-archive-list]');
	if (!list) {
		return;
	}

	function parseIds(value) {
		if (Array.isArray(value)) {
			return value
				.map(function (id) {
					return parseInt(id, 10) || 0;
				})
				.filter(function (id) {
					return id > 0;
				});
		}

		return String(value || '')
			.split(',')
			.map(function (id) {
				return parseInt(id, 10) || 0;
			})
			.filter(function (id) {
				return id > 0;
			});
	}

	function serializeIds(ids) {
		return parseIds(ids)
			.slice()
			.sort(function (a, b) {
				return a - b;
			})
			.join(',');
	}

	function idsEqual(a, b) {
		return serializeIds(a) === serializeIds(b);
	}

	function toggleId(ids, id) {
		var next = parseIds(ids);
		var index = next.indexOf(id);

		if (index === -1) {
			next.push(id);
		} else {
			next.splice(index, 1);
		}

		return next;
	}

	var state = {
		page: parseInt(root.getAttribute('data-page') || '1', 10) || 1,
		category: parseIds(root.getAttribute('data-category')),
		tag: parseIds(root.getAttribute('data-tag')),
		loading: false,
	};

	function updateUrl() {
		try {
			var url = new URL(window.location.href);
			if (state.page > 1) {
				url.searchParams.set('ratgeber_page', String(state.page));
			} else {
				url.searchParams.delete('ratgeber_page');
			}
			if (state.category.length) {
				url.searchParams.set('ratgeber_cat', serializeIds(state.category));
			} else {
				url.searchParams.delete('ratgeber_cat');
			}
			if (state.tag.length) {
				url.searchParams.set('ratgeber_tag', serializeIds(state.tag));
			} else {
				url.searchParams.delete('ratgeber_tag');
			}
			window.history.replaceState({}, '', url.toString());
		} catch (e) {}
	}

	function scrollToList() {
		var top = root.getBoundingClientRect().top + window.pageYOffset - 100;
		window.scrollTo({ top: top, behavior: 'smooth' });
	}

	function load(page, category, tag, shouldScroll) {
		if (state.loading) {
			return;
		}

		state.loading = true;
		root.classList.add('is-loading');

		var body = new FormData();
		body.append('action', 'didapress_ratgeber_archive');
		body.append('nonce', didapressRatgeberArchive.nonce);
		body.append('page', String(page));
		body.append('category', serializeIds(category));
		body.append('tag', serializeIds(tag));

		fetch(didapressRatgeberArchive.ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			body: body,
		})
			.then(function (response) {
				return response.json();
			})
			.then(function (payload) {
				if (!payload || !payload.success || !payload.data || typeof payload.data.html !== 'string') {
					throw new Error('invalid');
				}

				state.page = payload.data.page || page;
				state.category = parseIds(payload.data.category);
				state.tag = parseIds(payload.data.tag);
				root.setAttribute('data-page', String(state.page));
				root.setAttribute('data-category', serializeIds(state.category));
				root.setAttribute('data-tag', serializeIds(state.tag));
				list.innerHTML = payload.data.html;
				updateUrl();

				if (shouldScroll) {
					scrollToList();
				}
			})
			.catch(function () {
				window.alert(didapressRatgeberArchive.i18n.error);
			})
			.finally(function () {
				state.loading = false;
				root.classList.remove('is-loading');
			});
	}

	root.addEventListener('click', function (event) {
		var filterBtn = event.target.closest('[data-ratgeber-filter]');
		if (filterBtn && root.contains(filterBtn)) {
			event.preventDefault();
			var group = filterBtn.getAttribute('data-ratgeber-filter-group') || '';
			var termId = parseInt(filterBtn.getAttribute('data-ratgeber-filter') || '0', 10) || 0;
			if (!termId) {
				return;
			}

			var nextCategory = state.category.slice();
			var nextTag = state.tag.slice();

			if (group === 'ratgeber_category') {
				nextCategory = toggleId(nextCategory, termId);
			} else if (group === 'ratgeber_tag') {
				nextTag = toggleId(nextTag, termId);
			} else {
				return;
			}

			if (idsEqual(nextCategory, state.category) && idsEqual(nextTag, state.tag) && state.page === 1) {
				return;
			}

			load(1, nextCategory, nextTag, true);
			return;
		}

		var pageBtn = event.target.closest('[data-ratgeber-page]');
		if (pageBtn && root.contains(pageBtn)) {
			event.preventDefault();
			var nextPage = parseInt(pageBtn.getAttribute('data-ratgeber-page') || '1', 10) || 1;
			var pageCategory = parseIds(pageBtn.getAttribute('data-ratgeber-category') || serializeIds(state.category));
			var pageTag = parseIds(pageBtn.getAttribute('data-ratgeber-tag') || serializeIds(state.tag));
			if (nextPage === state.page && idsEqual(pageCategory, state.category) && idsEqual(pageTag, state.tag)) {
				return;
			}
			load(nextPage, pageCategory, pageTag, true);
		}
	});
})();
